export const CHECKOUT_WIZARD_STEPS = [
  { id: 0, label: "Pacote", hint: "Revise o pacote escolhido" },
  { id: 1, label: "Dados", hint: "E-mail e telefone para acesso" },
  { id: 2, label: "Pagamento", hint: "Como você quer pagar" },
] as const;

export type CheckoutWizardStepId = (typeof CHECKOUT_WIZARD_STEPS)[number]["id"];
